module.exports = __webpack_public_path__ + "star.mp3?a397d0bb051ffc6fc18c46ecf7b80c90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star.mp3
// module id = 24
// module chunks = 0